<template>
  <el-dialog
    :title="modalTitle"
    :visible="visible"
    width="950px"
    center
    :close-on-click-modal="true"
    @close="close()"
    class="custom-dialog"
  >

    <el-card shadow="always">

      <el-form :model="silo" ref="formSilo" :rules="rules">
        <!-- PRODUCT -->
        <div class="gridTemplate-five" style="margin-top: 0px !important">
          <p class="dialog-p-subtitle" style="margin-bottom: 12px !important;"> {{ i18nValues['product'] }} </p>

          <!-- Crop Type -->    
          <el-form-item :label="i18nValues['crop']" prop="cropType" style="margin-bottom: 8px;">
            <el-select  
              v-model="silo.cropType"
              :placeholder="i18nValues['crop']"
              filterable
              @change="onCropTypeChange"
            >
              <el-option
                v-for="item in variedades"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- Product Selection -->
          <el-form-item label="Brand" prop="brand" style="margin-bottom: 8px;">
            <el-select 
              v-model="silo.product.brand" 
              placeholder="Select product" 
              @change="retrieveFieldByProductIdInProduction()" 
              filterable
            >
              <el-option
                v-for="item in filteredProducts"
                :key="item.id"
                :label="item.brand"
                :value="item.brand"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- Displaying Variety (Product Name) -->
          <el-form-item :label="i18nValues['variety']" prop="variety" style="margin-bottom: 8px;">
            <el-input v-model="silo.product.name" disabled></el-input>
          </el-form-item>
        </div>

        <div></div>

        <!-- FIELD -->
        <div class="gridTemplate-five" style="margin-top: 2px !important; margin-bottom: 2px !important">
          <p class="dialog-p-subtitle" style="margin-bottom: 12px !important;"> {{ i18nValues['location'] }} </p>

          <el-form-item :label="i18nValues['field']" prop="field" style="margin-bottom: 8px;">
            <el-select
              v-model="silo.field"
              value-key="id"
              :placeholder="i18nValues['field']"
              filterable
              @change="retrieveFieldLotsByProductIdAndFieldInProduction()"
            >
              <el-option
                v-for="item in filterFields"
                :key="item.id"
                :label="item.name"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="i18nValues['batch']" prop="batch" style="margin-bottom: 8px;">
            <el-select 
              v-model="silo.batch" 
              :placeholder="i18nValues['batch']"
            >
              <el-option
                v-for="item in filterFieldLots"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div></div>

        <!-- TRANSPORT -->
        <div class="gridTemplate-five" style="margin-top: 2px !important; margin-bottom: 2px !important">
          <p class="dialog-p-subtitle" style="margin-bottom: 12px !important;"> {{ i18nValues['transport'] }} </p>

          <!-- Date -->
          <el-form-item :label="i18nValues['date']" prop="transportDate" style="margin-bottom: 8px;">
            <div class="input-group">
              <el-date-picker 
                type="date"
                class="calendar"
                format="dd/MM/yyyy"
                v-model="silo.transportDate"
                placeholder="Select date"
              >
              </el-date-picker>
              <span class="input-group-addon primary el-input__suffix icon">
                <span class="arrow"></span>
                <i class="fa fa-calendar-alt"></i>
              </span>
            </div>
          </el-form-item>

          <el-form-item :label="i18nValues['refer']" prop="refer" style="margin-bottom: 8px;">
            <el-input v-model="silo.refer"></el-input>
          </el-form-item>

          <div></div>
          <div></div>

          <el-form-item :label="i18nValues['carrierCompany']" prop="carrierCompany" style="margin-bottom: 8px;">
            <el-input v-model="silo.carrierCompany"></el-input>
          </el-form-item>

          <el-form-item :label="i18nValues['driver']" prop="driver" style="margin-bottom: 8px;">
            <el-input v-model="silo.driver"></el-input>
          </el-form-item>

          <!-- TruckPlate --> 
          <el-form-item :label="i18nValues['truckPlate']" prop="truckPlate" style="margin-bottom: 8px;">
            <el-input v-model="silo.truckPlate" maxlength="8"></el-input>
          </el-form-item>
                                        
          <!-- TrailerPlate -->    
          <el-form-item :label="i18nValues['trailerPlate']" prop="trailerPlate" style="margin-bottom: 8px;">
            <el-input v-model="silo.trailerPlate" maxlength="8"></el-input>
          </el-form-item> 

          <!-- TruckGrossWeight -->    
          <el-form-item :label="i18nValues['truckGrossWeight']" prop="truckGrossWeight" style="margin-bottom: 8px;">
            <el-input v-model="silo.truckGrossWeight" @keypress.native="isNumberWithDecimals($event)" maxlength="8"></el-input>
          </el-form-item> 
        </div>

        <div></div>

        <!-- VARIETY DATA -->
        <div class="gridTemplate-five" style="margin-top: 2px !important; margin-bottom: 2px !important">
          <p class="dialog-p-subtitle" style="margin-bottom: 12px !important;"> {{ i18nValues['varietyData'] }} </p>

          <el-form-item :label="i18nValues['humidity']" prop="humidity" style="margin-bottom: 8px;">
            <el-input v-model="silo.humidity" @keypress.native="isNumberWithDecimals($event)"></el-input>
          </el-form-item>

          <el-form-item :label="i18nValues['temperature']" prop="temperature" style="margin-bottom: 8px;">
            <el-input v-model="silo.temperature" @keypress.native="isNumberWithDecimals($event)"></el-input>
          </el-form-item>

          <el-form-item label="PS1000" prop="ps1000" style="margin-bottom: 8px;">
            <el-input v-model="silo.ps1000" @keypress.native="isNumberWithDecimals($event)"></el-input>
          </el-form-item>

          <el-form-item :label="i18nValues['visualQuality']" prop="visualQuality" style="margin-bottom: 8px;">
            <el-select 
              v-model="silo.visualQuality" 
              :placeholder="i18nValues['visualQuality']"
            >
              <el-option
                v-for="item in VisualTypesList"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="i18nValues['observations']" prop="comment" style="width: 200px; margin-bottom: 8px;">
            <el-input v-model="silo.comment"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <div>
      <div v-if="silo.product && silo.field.name">
        <div v-for="(siloItem, index) in selectedSilos" :key="index" class="gridTemplate silosStyle">
          <el-form-item :label="i18nValues['silo']" prop="silo" class="form-item">
            <el-select
              v-model="siloItem.id"
              :placeholder="i18nValues['silo']"
              filterable
            >
              <el-option
                v-for="item in availableSilos"  
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled" 
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="!isTaraOperation" :label="i18nValues['quantity'] + ' (kg)'" prop="quantityToSet" class="form-item">
            <el-input v-model="siloItem.quantityToSet" @keypress.native="isNumber($event)" @input="handleInput"></el-input>
          </el-form-item>

          <!-- Remove -->
          <div class="form-item">
            <el-button
              v-if="selectedSilos.length > 1"
              class="text-danger"
              style="margin-top: 30px;"
              icon="fas fa-times"
              size="small"
              :title="i18nValues['remove']"
              @click="removeSiloSelect(siloItem.id)"
            ></el-button>
          </div>
        </div>
      </div>
      
      <div v-if="silo.product && silo.field.name" class="button-style-add">
        <el-button 
          @click="addSiloSelect"
          icon="fas fa-plus"
          id="searchButton"
          size="small"
          class="btn-primary custom-button"
        >
          {{ i18nValues['addSilo'] }}     
        </el-button>
      </div>

      <div class="button-style-save">
        <el-button
          icon="fas fa-check"
          :loading="loading"
          size="small"
          class="btn-primary"
          @click="saveSilos()"
        >
          {{ i18nValues["save"] }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
export default {
  name: "SiloModal",
  created() {
    this.retrieveProducts();
    this.retrieveFields();

    if (this.isTaraOperation === false) {
      this.retieveSelecetedRelatedSilos();
    }

    this.rules = {
      refer: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      field: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      batch: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      product: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      cropType: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      humidity: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      temperature: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
      transportDate: [{ required: true, message: this.i18nValues["required"], trigger: "blur" }],
    };
  },

  computed: {
    loading: get("silo/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
    i18nValues: get("i18nStore/valuesRetrieved"),

    filteredProducts() {
      if (!this.silo.cropType || !this.ProductList) return [];
      if (!this.cropProductions || this.cropProductions.length === 0) return [];
      
      let filtered = this.ProductList.filter(
        product => product.cropType === this.silo.cropType
      );
      
      filtered = filtered.filter(
        product => this.cropProductions.some(
          cp => cp.product && cp.product.id === product.id
        )
      );
      
      return filtered;
    },

    availableSilos() {
      return this.SilosListFiltered
        .map(silo => {
          const isSelected = this.selectedSilos.some(selected => selected.id === silo.id);
          return {
            ...silo,
            disabled: isSelected
          };
        })
        .sort((a, b) => {
          const nameA = a.name ? a.name.match(/\d+/) : null;
          const nameB = b.name ? b.name.match(/\d+/) : null;
          const numA = nameA ? parseInt(nameA[0], 10) : 0;
          const numB = nameB ? parseInt(nameB[0], 10) : 0;
          if (numA !== numB) {
            return numA - numB;
          }
          return (a.name || '').localeCompare(b.name || '');
        });
    },

    VisualTypesList() {
      return [
        { id: 1, name: this.i18nValues['good'], value: "good" },
        { id: 2, name: this.i18nValues['regular'], value: "regular" },
        { id: 3, name: this.i18nValues['bad'], value: "bad" }
      ];
    }
  },

  watch: {
    // Whenever the cropType changes, re-retrieve the CropProductions.
    "silo.cropType"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.retrieveCropProductions();
      }
    }
  },

  components: { },

  props: ["modalTitle", "visible", "SilosList", "isTaraOperation"],

  data() {
    return {
      silo: {
        quantityToSet: 0,
        batch: '',
        product: {},
        field: {},
        transportDate: new Date(),
        cropType: null, // selected crop type
      },
      ProductList: [],
      SilosListFiltered: [],
      FieldsList: [],
      FieldLotsList: [],
      selectedSilos: [
        { id: null, quantityToSet: null } 
      ],
      variedades: [
        { value: "corn", label: "Corn Seed" },
        { value: "soy", label: "Soybean Production" },
        { value: "soyRD", label: "Soybean R&D" },
      ],
      filterFields: [{}],
      filterFieldLots: [{}],
      // New property for storing CropProduction objects.
      cropProductions: []
    };
  },

  methods: {
    addSiloSelect() {
      const lastSilo = this.selectedSilos[this.selectedSilos.length - 1];
      if (!lastSilo || !lastSilo.id) {
        this.$message.warning("Por favor, selecciona un silo antes de agregar uno nuevo.");
        return;
      }
      this.selectedSilos.push({ id: null, quantityToSet: null, name: null });
    },

    retrieveProducts() {
      this.filter = {};
      this.filter.campaignId = this.globalCampaign ? this.globalCampaign.id : null;
      this.$store.dispatch("product/retrieveProducts", this.filter).then((res) => {
        this.ProductList = res;
      });        
    },

    close() {
      this.silo = {
        product: {},
        field: {},
        batch: '',
        transportDate: new Date(),
        cropType: null,
      };
      this.SilosListFiltered = [];
      this.selectedSilos = [];
      this.$emit("update:visible", false);
    },

    retrieveSilos() {
      this.$store.dispatch("silo/retrieveSilos").then((res) => {
        this.SilosList = res;
        this.SilosList = res.filter(silo => !silo.pending);
        this.$emit("update:visible", false);
      });
    },

    retrieveFields() {
      this.$store.dispatch("field/retrieveFields").then((res) => {
        this.FieldsList = res;
      });
    },

    retrieveFieldByProductIdInProduction() {
      this.silo.field = {};
      this.silo.batch = null;

      this.ProductList.forEach(product => {
          if (product.brand === this.silo.product.brand) {
            Object.assign(this.silo.product, product);
          }
      });

      let filter = {
        id: this.silo.product.id,
        campaignId: this.globalCampaign.id
      }

      this.$store.dispatch("silo/retrieveFieldByProductIdInProduction", filter)
        .then((res) => {
          this.filterFields = res;
        });
    },


    retrieveFieldLotsByProductIdAndFieldInProduction() {
      this.silo.batch = null;
      let filter = {
        productId: this.silo.product.id,
        fieldId: this.silo.field.id
      };
      this.$store.dispatch("silo/retrieveFieldLotsByProductIdAndFieldInProduction", filter).then((res) => {
        this.filterFieldLots = res;
      });
      if (this.silo.product.id != null && this.silo.field.id != null) {
        this.retrieveSilosByProductBrandAndField();
      }
    },

    retrieveSilosByProductBrandAndField() {
      let filter = {
        brand: this.silo.product.brand,
        fieldSiteId: this.globalFieldSite.id,
        fieldId: this.silo.field.id
      };
      this.$store.dispatch("silo/retrieveSilosByProductBrandAndField", filter).then((res) => {
        this.SilosListFiltered = res.filter(silo => {
          if (silo.pending) return false;
          if (silo.status === 'inTara' && silo.product.brand !== filter.brand) {
            return silo.brand === filter.brand && silo.field.id === filter.fieldId;
          }
          return true;
        });
        this.SilosList.forEach(silo => {
          if (silo.product === null && silo.type !== 'discard' && !silo.pending && silo.status !== 'inTara') {
            this.SilosListFiltered.push(silo);
          } 
          if (silo.product !== null && silo.product.brand === filter.brand && silo.field.id === filter.fieldId) {
            this.SilosListFiltered.push(silo);
          }
        });
        this.SilosListFiltered = this.SilosListFiltered.filter((silo, index, self) => {
          return index === self.findIndex(item => item.id === silo.id);
        });
        this.selectedSilos = [{ id: null, quantityToSet: null }];
      });
    },

    retrieveCropProductions() {
      if (!this.silo.cropType || !this.globalFieldSite || !this.globalCampaign) {
        this.cropProductions = [];
        return;
      }
      this.$store.dispatch("campaign/retrieveCropProductions", this.globalCampaign.id)
        .then((res) => {
          this.cropProductions = res;
        })
        .catch(() => {
          this.cropProductions = [];
        });
    },

    onCropTypeChange() {
      this.silo.product = {};
      this.silo.field = {};
      this.silo.batch = null;
      this.retrieveCropProductions();
    },

    removeSiloSelect(id) {
      this.selectedSilos = this.selectedSilos.filter(silo => silo.id !== id);
    },

    saveSilos() {
      if (this.isTaraOperation) {
        this.taraOperation();
      }
    },

    taraOperation() {
      let siloToSave = {
        relatedSilos: this.selectedSilos,
        user: this.user ? this.user.name : "unknown",
        fieldSite: this.globalFieldSite,
      };
      siloToSave = this.mergeSiloInfo(siloToSave, this.silo);
      this.$store.dispatch("silo/addTara", siloToSave).then((res) => {
        if (res.status === "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["siloTaraSave"],
            position: "bottom-right",
          });
          this.$emit("update:Silos");
          this.$emit("update:visible", false);
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["SiloSavedError"],
            position: "bottom-right",
          });
        }
      });
    },

    mergeSiloInfo(originalSilo, newSiloData) {
      let mergedSilo = { ...originalSilo };
      if (newSiloData.product && typeof newSiloData.product === 'number') {
        mergedSilo.product = {
          id: newSiloData.product.id, 
          name: originalSilo.product ? originalSilo.product.name : 'Desconocido' 
        };
      } else if (newSiloData.product && typeof newSiloData.product === 'object') {
        mergedSilo.product = { ...originalSilo.product, ...newSiloData.product };
      }
      if (newSiloData.batch && typeof newSiloData.batch === 'number') {
        mergedSilo.fieldLot = {
          id: newSiloData.batch, 
          name: originalSilo.batch ? originalSilo.batch.name : 'Desconocido' 
        };
      } else if (newSiloData.batch && typeof newSiloData.batch === 'object') {
        mergedSilo.fieldLot = { ...originalSilo.batch, ...newSiloData.batch };
      }
      mergedSilo = { ...mergedSilo, ...newSiloData };
      return mergedSilo;
    },

    retieveSelecetedRelatedSilos() {
      this.selectedSilos = this.silo.relatedSilos;
    }
  },
};
</script>

<style scoped>
.custom-button {
  margin-top: 10px;
  padding: 7px 12px;
}

.silosStyle {
  margin-left: 20px; 
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.button-style-add {
  margin-left: 20px;
}

.button-style-save {
  display: flex; 
  justify-content: flex-end; 
  margin-right: 15px;
  margin-top: 15px;
}

.custom-dialog .el-dialog__header {
  background-color: #009d57 !important; 
  color: #009d57 !important; 
}

/* Prevent validation messages from overlapping with subtitles */
.gridTemplate-five .dialog-p-subtitle {
  margin-bottom: 12px !important;
  padding-bottom: 4px;
}

.gridTemplate-five .el-form-item {
  margin-bottom: 8px !important;
}

.gridTemplate-five .el-form-item__error {
  position: relative;
  margin-top: 2px;
  padding-top: 0;
}
</style>
